/**
 * Table header component
 */

// React
import React from 'react';

// Material
import { TableCell, TableRow, TableSortLabel } from '@mui/material';

// Component
import CustomSortIcon from './CustomSortIcon';

// Models
import { IParamGetList } from 'models/UserRequest';

// Utils
import { RowHeader } from 'utils/types';

// Interface
interface TableHeaderProps<T, Y> {
  children?: React.ReactNode | React.ReactElement;
  paramsGetList?: T;
  header: RowHeader[];
  handleRequestSort: (_id: keyof Y) => void;
  isSortable?: (_id: string | undefined) => boolean;
}

// Component
const TableHeader = <T extends IParamGetList, Y>({
  header,
  children,
  isSortable,
  paramsGetList,
  handleRequestSort,
}: TableHeaderProps<T, Y>): JSX.Element => {
  return (
    <TableRow>
      {children}
      {header.map(({ id, label, position, haveSort }, index) => (
        <TableCell
          key={index}
          align={position ?? 'left'}
          style={{
            cursor: isSortable && isSortable(id) && haveSort !== false ? 'pointer' : 'default',
          }}
        >
          {isSortable && isSortable(id) && haveSort !== false ? (
            <TableSortLabel
              sx={{
                alignItems: 'baseline',
                '&:hover': {
                  color: 'inherit',
                },
              }}
              active={paramsGetList?.sort_name === id}
              onClick={() => handleRequestSort(id as keyof Y)}
              direction={paramsGetList?.sort_name === id ? paramsGetList?.order_by : 'asc'}
              IconComponent={() => (
                <CustomSortIcon
                  direction={
                    paramsGetList?.sort_name === id
                      ? (paramsGetList?.order_by as 'asc' | 'desc')
                      : 'asc'
                  }
                />
              )}
            >
              {label}
            </TableSortLabel>
          ) : (
            <>{label}</>
          )}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default TableHeader;
